<template>
  <component :is="data.type" :key="uuid" :data="data"></component>
</template>

<script>
import { uuid } from '@/helpers'

import ItineraryDay from './custom-content-loader/itinerary-day.vue'
import HeaderTitle from './custom-content-loader/header-title.vue'
import HeaderText from './custom-content-loader/header-text.vue'
import TabShare from './custom-content-loader/tab-share.vue'

export default {
  name: 'BaseContentLoader',
  components: {
    ItineraryDay,
    HeaderTitle,
    HeaderText,
    TabShare
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    uuid () {
      return uuid()
    }
  }
}
</script>

<style>
</style>
